export enum Gender {
  MALE,
  FEMALE,
  UNKNOWN,
}

export const mapStringToGender = (gender?: string): Gender => {
  switch (gender && gender.toUpperCase()) {
    case "MALE":
      return Gender.MALE;
    case "FEMALE":
      return Gender.FEMALE;
    default:
      return Gender.UNKNOWN;
  }
};
